'use strict';

var _typeof = require('@babel/runtime/helpers/typeof');
var React = require('react');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function getReactNode(content, props) {
  if (content === undefined) {
    return null;
  }
  if (Array.isArray(content)) {
    return content.map(function (item) {
      return getReactNode(item);
    });
  }
  if ( /*#__PURE__*/React__default["default"].isValidElement(content) || ['string', 'number', 'boolean'].includes(_typeof__default["default"](content))) {
    return content;
  }
  var ContentComponent = content;
  if ( /*#__PURE__*/React__default["default"].isValidElement(react.jsx(ContentComponent, null))) {
    return react.jsx(ContentComponent, props);
  }
  return null;
}

exports.getReactNode = getReactNode;
//# sourceMappingURL=getReactNode-625f4d64.js.map
